import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store.js'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "home" */ './views/Home.vue'),
      meta: {
        title: 'Home',
        auth: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ './views/Login.vue'),
      meta: {
        title: 'Location Agency Dashboard',
        auth: false
      }
    },
    {
      path: '/locations',
      name: 'locations',
      component: () => import(/* webpackChunkName: "locations" */ './views/Locations.vue'),
      meta: {
        title: 'Locations',
        auth: true
      }
    },
    {
      path: '/locations/:id',
      name: 'location',
      component: () => import(/* webpackChunkName: "location" */ './views/Location.vue'),
      meta: {
        title: 'Location',
        auth: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    store.commit('TITLE', to.meta.title)
  }

  if (to.matched.some(record => record.meta.auth)) {
    if (!store.state.token) {
      next({
        path: '/login'
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
